<template>
  <v-carousel cycle :show-arrows="false">
    <v-carousel-item
      v-for="(item, i) in items"
      :key="i"
      :src="item.src"
      class="banner"
    >
      <v-flex xs12>
        <span class="banner_txt" v-text="item.txt"> </span>
      </v-flex>
    </v-carousel-item> 
  </v-carousel>
</template>

<script>
import imgUrl from "../assets/image/banner/banner01.jpg";
import imgUrl2 from "../assets/image/banner/banner02.jpg";
import imgUrl3 from "../assets/image/banner/banner03.jpg";
export default {
  data() {
    return {
      items: [
        // {
        //   src: 'http://localhost/vue/dep2640/images/banner/banner01.png',
        // },
        // {
        //   src: 'http://localhost/vue/dep2640/images/banner/banner02.png',
        // },
        // {
        //   src: 'http://localhost/vue/dep2640/images/banner/banner03.png',
        // },
        {
          src: imgUrl,
          txt: "我們永遠在你身邊",
        },
        {
          src: imgUrl2,
          txt: "請記得有我，陪你前行",
        },
        {
          src: imgUrl3,
          txt: "生命守護, 一路相陪",
        },
      ],
    };
  },
};
</script>

<style>
.banner {
  margin-top: 15px;
  background-color: #fd8e7c;
}
/*------------ banner ------------*/
.banner img {
  width: 100%;
  height: auto;
  max-height: 500px;
}
.banner * {
  height: 100%;
}
.banner img {
  object-fit: cover;
  height: 100% !important;
  width: 100% !important;
  max-width: inherit;
}

.v-carousel__controls {
  background: rgba(0, 0, 0, 0) !important;
}
.banner_txt {
  font-weight: 400;
  font-size: 40px;
  margin-bottom: 1%;
  margin-right: 4rem;
  color: #fff;
}
.v-responsive__content {
  padding-top: 100px !important;
  /* background-color: rgb(20, 19, 19);
    opacity: 0.2; */
  text-align: right;
  margin-right: 4rem;
  animation: fadein 6s ease;
}
/* banner文字淡入淡出 */
@keyframes fadein {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@media (max-width: 990px) {
  .banner {
    margin-top: 5px;
  }
}
@media (max-width: 800px) {
  .banner_txt {
    font-weight: 400;
    font-size: 34px;
    margin-bottom: 1%;
    margin-right: 0rem;
    color: #fff;
  }
}
</style>
